<ng-container *ngIf="globalInitService.isLoadingKey | isLoading | async; else loadingView">
  <div class="loading-container">
    <oui-loading></oui-loading>
  </div>
</ng-container>

<ng-template #loadingView>
  <router-outlet></router-outlet>
</ng-template>
